import * as React from "react";
import * as Loadable from "react-loadable";

const loading = ({ error, timedOut, pastDelay }) => {
  if (error) {
    return <div>Error!</div>;
  } else if (timedOut) {
    return <div>Time out!</div>;
  } else if (pastDelay) {
    return <div>Loading...</div>;
  } else {
    return null;
  }
};

const asyncComponent = (loader: () => Promise<any>) =>
  Loadable({
    loader,
    loading,
    delay: 500,
    timeout: 10000
  });

export default asyncComponent;
